import React, { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import api, { getDiscordRedirectUri } from '../api';

const DISCORD_MESSAGE = 'EUGENIAL_DISCORD_LINK';

const wrap: React.CSSProperties = {
  minHeight: '100vh',
  padding: '2rem',
  background: '#0D0B1E',
  color: '#fff',
  fontFamily: 'Poppins, sans-serif',
};

const DiscordCallbackPage: React.FC = () => {
  const [params] = useSearchParams();
  const [error, setError] = useState('');
  const [done, setDone] = useState(false);

  useEffect(() => {
    const oauthError = params.get('error');
    if (oauthError) {
      const msg = params.get('error_description') || oauthError;
      setError(msg);
      if (window.opener && !window.opener.closed) {
        window.opener.postMessage(
          { type: DISCORD_MESSAGE, ok: false, error: msg },
          window.location.origin
        );
      }
      return;
    }

    const code = params.get('code');
    if (!code) {
      setError('Sin código OAuth');
      return;
    }

    if (!localStorage.getItem('eugenial_twitch_token')) {
      setError('Primero conectá Twitch en la ventana principal, después Discord.');
      return;
    }

    api
      .post('/discord/auth/callback', {
        code,
        redirect_uri: getDiscordRedirectUri(),
      })
      .then(({ data }) => {
        setDone(true);
        if (window.opener && !window.opener.closed) {
          window.opener.postMessage(
            {
              type: DISCORD_MESSAGE,
              ok: true,
              discord: data.discord,
              linked: data.linked,
            },
            window.location.origin
          );
          window.close();
        }
      })
      .catch((err) => {
        const msg = err?.response?.data?.message || 'Error al vincular Discord';
        setError(msg);
        if (window.opener && !window.opener.closed) {
          window.opener.postMessage(
            { type: DISCORD_MESSAGE, ok: false, error: msg },
            window.location.origin
          );
        }
      });
  }, [params]);

  return (
    <div style={wrap}>
      <h1 style={{ color: '#FF1493', fontFamily: 'Orbitron, sans-serif' }}>
        {error ? 'Error Discord' : done ? 'Discord vinculado' : 'Conectando Discord...'}
      </h1>
      <p style={{ color: '#B8A9C9' }}>
        {error || 'Podés cerrar esta ventana.'}
      </p>
    </div>
  );
};

export default DiscordCallbackPage;
